import { animations, pixelCornersCss } from "../helpers/cssImports";
import { css, html, htmlArray } from "../helpers/webComponents";
import { GameRouteService } from "../services/GameRouteService";

/** CSS affecting the {@link LogoutComponent} */
const style: string = css`
.try-again-btn {
    font-family: "pixel";
    position: fixed;
    background-color: rgb(15, 122, 237);
    box-shadow: -4px 0 0 0 white,
        4px 0 0 0 white,
        0 -4px 0 0 white,
        0 4px 0 0 white;
    width: 80px;
    height: 50px;
    right: 1%;
    bottom: 20%;
    color: white;
    font-size: 30px;
    transition: background-color 0.3s ease-in-out;
    text-shadow: 
    -2px -2px 0 black,  
    2px -2px 0 black,  
    -2px  2px 0 black,  
    2px  2px 0 black;
    line-height: 0.7;
}

.try-again-btn:hover {
    background-color: black;
    animation: hover 0.5s ease-in-out 2 forwards, glow 0.5s infinite;
}

dialog {
    background-color: rgb(15, 122, 237);
}

dialog::backdrop {
    background-color: rgba(0, 0, 0, 0.5);
    backdrop-filter: blur(5px);
}

dialog section {
    margin: 5%;
}

.content {
    font-size: 45px;
    font-family: "pixel";
}

.title {
    font-size: 30px;
}

h1 {
    text-shadow: 
        -4px -4px 0 white,  
        4px -4px 0 white,  
        -4px  4px 0 white,  
        4px  4px 0 white;

}

.content {
    color: white;
    text-shadow: 
        -2px -2px 0 black,  
        2px -2px 0 black,  
        -2px  2px 0 black,  
        2px  2px 0 black;
}

.btns {
    display: flex;
    flex-direction: row;
    justify-content: center;
    align-items: center;
} 

dialog button {
    padding: 3%;
    margin: 2%;
    width: 50%;
    box-shadow: -5px 0 0 0 white,
    5px 0 0 0 white,
    0 -5px 0 0 white,
    0 5px 0 0 white;
    color: white;
    font-family: "pixel";
    font-size: 45px;
}

.cancel {
    background-color: rgb(15, 122, 237);
    transition: background-color 0.3s ease-in-out;

}

.confirm {
    background-color: rgb(0, 62, 129);
    transition: background-color 0.3s ease-in-out;
}

.cancel:hover, .confirm:hover {
    background-color: black;
    animation: hover 0.5s ease-in-out 2 forwards, glow 0.5s infinite;
}

${animations}
${pixelCornersCss}
`;

/**
 * Represents the try again web component
 * Handles the try again functionality
 */
export class TryAgainComponent extends HTMLElement {
    private readonly _gameRouteService: GameRouteService = new GameRouteService();

    /**
     * Constructor of the web component
     */
    public connectedCallback(): void {
        this.attachShadow({ mode: "open" });
        this.render();
    }

    /**
     * Renders the try again button.
     * sets up event listeners for buttons and dialog
     */
    private render(): void {
        if (!this.shadowRoot) {
            return;
        }

        const tryAgainDialog: HTMLDialogElement = this.createTryAgainDialog();
        const elements: HTMLElement[] = htmlArray`
            <style>
                ${style}
            </style>
            ${this.createTryAgainBtn()}
            ${tryAgainDialog}
                 
        `;

        this.shadowRoot.append(...elements);
        this.setUpTryAgainBtn(tryAgainDialog);
        this.setUpTryAgainDialog(tryAgainDialog);
    }

    /**
     * Creates the try again button
     * @returns - The created try again button
     */
    private createTryAgainBtn(): HTMLElement {
        const element: HTMLElement = html`
            <button class="try-again-btn">TRY AGAIN</button>
        `;
        return element;
    }

    /**
     * Creates the try again dialog
     * @returns - The created dialog
     */
    private createTryAgainDialog(): HTMLDialogElement {
        const element: HTMLDialogElement = html`
        <dialog class="pixel-corners--wrapper">
            <section class="title">
                <h1>TRY AGAIN CONFIRMATION</h1>
            </section>
            <section class="content">
                <p>Are you sure you want to continue? All previous data will be deleted.</p>
            </section>
            <section class="footer">
                <div class="btns">
                    <button class="confirm">CONFIRM</button>
                    <button class="cancel">CANCEL</button>
                </div>
            </section>
        </dialog>
        ` as HTMLDialogElement;
        return element;
    }

    /**
     * Sets up the event listener for the try again button
     * @param dialog - The try again dialog
     */
    private setUpTryAgainBtn(dialog: HTMLDialogElement): void {
        const btn: HTMLElement = this.shadowRoot?.querySelector(".try-again-btn") as HTMLElement;

        btn.addEventListener("click", () => {
            dialog.showModal();
        });
    }

    /**
     * Sets up event listeners for the try again dialog
     * handles confirm and cancel
     * @param dialog - The try again dialog
     */
    private setUpTryAgainDialog(dialog: HTMLDialogElement): void {
        const confirmBtn: HTMLElement = dialog.querySelector(".confirm") as HTMLElement;
        const cancelBtn: HTMLElement = dialog.querySelector(".cancel") as HTMLElement;

        cancelBtn.addEventListener("click", () => dialog.close());
        confirmBtn.addEventListener("click", () => this.handleConfirmClick(dialog));
    }

    /**
     * Handles the confirm action.
     * Resets the playersession data
     * @param dialog - The try again dialog
     */
    private async handleConfirmClick(dialog: HTMLDialogElement): Promise<void> {
        await this._gameRouteService.resetPlayerSession();
        dialog.close();
        location.reload();
    }
}
